import { render, staticRenderFns } from "./commercialeDistributori.vue?vue&type=template&id=57705bb9&"
import script from "./commercialeDistributori.vue.ts?vue&type=script&lang=ts&"
export * from "./commercialeDistributori.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports